import { registerComponent } from '@gig/magic-common';
import KeycloakLoginComponent from './keycloak-login.vue.js';

var KeycloakLogin = registerComponent(KeycloakLoginComponent);

export { KeycloakLogin };
